import {Card, IconButton, Typography, Tooltip} from "@material-tailwind/react";
import {PlusIcon, InformationCircleIcon} from "@heroicons/react/24/solid";
import {TrashIcon} from "@heroicons/react/24/outline";
import {Field} from "formik";
import {InputTable} from "../../../components/elements/Inputs/InputComponent";
import {AsyncSelectField, SelectComponent} from "../../../components/elements/Inputs/SelectComponent";

const TABLE_HEAD = ["#", "Producto", "En Bodega", "Cantidad A Transferir", ""];

export function TransferDetails({push, values, searchProduct, remove}) {
  return (
    <Card className="h-full w-full rounded-none p-4" style={{flexBasis: '150px !important'}}>
      <div className="w-full flex flex-row justify-between">
        <Typography
          variant="small"
          color="black"
          className="mb-1"
        >
          Ingrese cada uno de los productos que desee transferir a otra sucursal.
        </Typography>
      </div>
      <table className="w-full min-w-full table-auto text-left">
        <thead>
        <tr>
          {TABLE_HEAD.map((head, index) => {
            const isLast = index === TABLE_HEAD.length - 1;
            const classes = isLast ? "text-right" : "";

            return (
              <th
                key={head + index}
                className={`border-b border-blue-gray-100 px-2 py-3 table-cell`}
              >
                <Typography
                  variant="small"
                  color="blue-gray"
                  className={`font-normal leading-none opacity-70 ${classes}`}
                >
                  {head}
                </Typography>
              </th>
            )
          })
          }
        </tr>
        </thead>
        <tbody>
        {values?.transfer_detail.map((itemDetail, index) => {
          const classes = "px-2 py-0 border-b border-blue-gray-50";
          return (
            <tr key={index}>
              <td className={classes}>
                <Typography variant="small" color="black" className="opacity-90">
                  {index + 1}
                </Typography>
              </td>
              <td className={classes}>
                <Field
                  loadOptions={searchProduct}
                  placeholder="buscar..."
                  menuPlacement="top"
                  name={`transfer_detail.${index}.product_presentation`}
                  component={AsyncSelectField}
                />
              </td>
              {/* <td className={classes}>
                <SelectComponent
                  classSubContainer=""
                  isClearable={false}
                  hideError={true}
                  options={warehouse}
                  name={`transfer_detail.${index}.warehouse_origen`}
                />
              </td>
              <td className={classes}>
                <SelectComponent
                  classSubContainer=""
                  isClearable={false}
                  hideError={true}
                  options={warehouse}
                  name={`transfer_detail.${index}.warehouse_destino`}
                />
              </td> */}
              <td className={classes}>
                <span>{itemDetail?.product_presentation?.inventario?.quantity}</span>
              </td>
              <td className={classes + " flex flex-row gap-2 my-auto items-center"}>
                <InputTable
                  maxLength={4}
                  name={`transfer_detail.${index}.quantity`}
                />
                {itemDetail?.product_presentation?.inventario?.quantity < itemDetail.quantity &&
                  <span className="text-red-400 text-[12px]">Verifique existencia</span>
                }
              </td>
              <td className={classes + " text-justify"}>
              <IconButton
                  onClick={() => remove(index)}
                  className={`font-normal text-red-400 bg-gray-100 hover:shadow-black/10`}
                >
                  <TrashIcon className="w-4 h-4"></TrashIcon>
                </IconButton>
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
      <div className="flex flex-row mt-6 justify-end">
        <Tooltip content="Agreagr una fila" placement="bottom">
          <IconButton className="right-0" onClick={() => push({price: "0"})}>
            <PlusIcon className="w-5 h-5"></PlusIcon>
          </IconButton>
        </Tooltip>
      </div>
    </Card>
  );
}